import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    DELETE_PRODUCT,
    GET_CALCULATED_PRICE,
    GET_PRODUCT_DETAIL,
    GET_PRODUCT_LIST, GET_USER_PRODUCT_LIST, REGISTER_BOOKMARK, REGISTER_BORROW_REQUEST, UPDATE_STATUS,
} from "./Product.type";
import ProductService from "../services/Product.service";
import {BorrowRequestModel, ProductListFilterModel} from "../models";

export const getProductList = createAsyncThunk(
    GET_PRODUCT_LIST,
    async (model:ProductListFilterModel) =>{
        const response = await ProductService.getProductList(model);
        return response.data;
    }
)
export const getUserProductList = createAsyncThunk(
    GET_USER_PRODUCT_LIST,
    async () =>{
        const response = await ProductService.getUserProductList();
        return response.data;
    }
)
export const getProductDetail = createAsyncThunk(
    GET_PRODUCT_DETAIL,
    async (id:string) =>{
        const response = await ProductService.getProductDetail(id);
        return response.data;
    }
)
export const getCalculatedProductPrice = createAsyncThunk(
    GET_CALCULATED_PRICE,
    async (model:any) =>{
        const response = await ProductService.getCalculateProductPrice(model);
        return response.data;
    }
)
export const registerBookMark = createAsyncThunk(
    REGISTER_BOOKMARK,
    async (id:string) =>{
        const response = await ProductService.registerBookMark(id);
        return response.data;
    }
)
export const registerBorrowRequest = createAsyncThunk(
    REGISTER_BORROW_REQUEST,
    async (model:BorrowRequestModel) =>{
        const response = await ProductService.registerBorrowRequest(model);
        return response.data;
    }
)
export const deleteProduct = createAsyncThunk(
    DELETE_PRODUCT,
    async (productId :string) =>{
        const response = await ProductService.deleteProduct(productId);
        return response.data;
    }
)
export const updateStatus = createAsyncThunk(
    UPDATE_STATUS,
    async (model :any) =>{
        const response = await ProductService.updateStatus(model);
        return response.data;
    }
)
